<template>
  <div class="toolbar" v-if="companyName != ''" style="position: relative">
    <router-link v-if="checkClaim(CAN_ADD_REQUIREMENTS)" :to="`/requirements/form?customer=${companyId}`">
      <b-button size="sm" variant="outline-primary">
        Add Requirement
      </b-button>
    </router-link>

    <b-button v-if="checkClaim(CAN_ADD_OFFERS)" size="sm" variant="outline-primary" @click="$bvModal.show('global-offer-modal')">
      Add Offer
    </b-button>

    

    <add-quote v-if="checkClaim(CAN_ACCESS_QUOTES)" :companyId="companyId" :companyName="companyName" />

    <add-sales-order v-if="checkClaim(CAN_ADD_SALES_ORDER)" :companyId="companyId" :companyName="companyName" />

    <add-purchase-order v-if="checkClaim(CAN_ADD_POS)" :companyId="companyId" :companyName="companyName" />

    <!-- <add-invoice v-if="isCustomer && checkClaim(CAN_ADD_INVOICES)" :companyId="companyId" :companyName="companyName" /> -->

    <add-crma v-if="isCustomer && checkClaim(CAN_ADD_RMAS)" :companyName="companyName" class="mr-2" :modalId="'toolbar-crma-modal'" />

    <add-vrma v-if="isVendor && checkClaim(CAN_ADD_VENDOR_RETURNS)" :companyName="companyName" class="mr-2" />
    
    <b-button size="sm" @click="openTodoModal" variant="outline-primary" class="mr-2">
      Add Task
    </b-button> 

    <add-offer v-if="checkClaim(CAN_ADD_OFFERS)" :modalId="'global-offer-modal'" :companyId="companyId" class="mr-2" />
    <!-- style="position: absolute; right: 10px; top: 5px;" -->
     
    <add-task :editDetails="taskDetails" modalId="toolbar-add-task" fromCompanyPage />
  </div>
</template>

<script>
import AddQuote from '@/pages/Quotes/components/AddQuote/index';
import AddSalesOrder from '@/pages/SalesOrders/components/add/index';
import AddPurchaseOrder from '@/pages/PurchaseOrders/components/add/index';
import AddInvoice from '@/pages/Invoices/components/add/index';
import AddCrma from '@/pages/Customerrmas/components/add/index';
import AddVrma from '@/pages/Vendorrmas/components/add/index';
import AddOffer from '@/shared/components/Offers/components/AddOffer';
import AddTask from '@/pages/Todotasks/components/add';

export default {
  name: 'BlueToolbar',
  props: {
    companyId: {
      type: [Number, String],
      default: 0,
    },
    companyName: {
      type: String,
      default: '',
    },
    isVendor: {
      type: Boolean,
      default: false,
    },
    isCustomer: {
      type: Boolean,
      default: false,
    },
    salesRep: {
      type: String,
      default: ''
    }
  },
  components: {
    AddQuote,
    AddSalesOrder,
    AddPurchaseOrder,
    AddInvoice,
    AddCrma,
    AddVrma,
    AddOffer,
    AddTask
  },
  data() {
    return {
      taskDetails: {}
    }
  },
  methods: {
    showAddQuoteModal() {
      this.$refs['add-quote-modal'].show();
    },
    openTodoModal() {
      this.taskDetails = {};
      this.taskDetails.companyId = this.companyId;
      this.taskDetails.companyName = this.companyName;
      this.taskDetails.assignedToUserId = this.salesRep;

      this.$bvModal.show('toolbar-add-task');
    },
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  margin-bottom: 1rem;

  button {
    margin-right: 0.5rem;
  }
}
.navigation-left{
  margin-left: 0.3rem;
}
.navigation-right{
  margin-right: 0.3rem;
}
</style>
